<template>
  <b-dropdown
    class="select-target"
    variant="outline-default"
    menu-class="menu-shadow scrollable text-medium"
    toggle-class="rounded-pill flex-center justify-content-between"
  >
    <template slot="button-content">
      <div class="text-truncate button-content" :title="selectedLabel" v-no-capture>
        {{ selectedLabel }}
      </div>
    </template>
    <b-dropdown-item @click="$emit('change', option.id)" v-for="option in options" :key="option.id"
      >{{ option.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { ENTITY_TYPE } from '@/constants/entities'

/**
 * This component shows a dropdown target for initiative, i.e Project/Goal
 * @emits
 * - change: emitted when dropdown item is selected
 */
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
  name: 'InitiativeTargetTypeDropdown',
  props: {
    selected: String
  },
  components: {
    BDropdown,
    BDropdownItem
  },
  data() {
    return {
      options: [
        { id: ENTITY_TYPE.GOAL, label: 'Goals' },
        { id: ENTITY_TYPE.PROJECT, label: 'Projects' }
      ]
    }
  },
  computed: {
    selectedLabel() {
      return this.options.find(op => op.id === this.selected)?.label
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

$dropdown-width: 120px;

/deep/ button {
  text-align: left;
  border-color: $borderPrimary;
}

/deep/ .button-content {
  width: $dropdown-width;
}

/deep/ .dropdown-menu {
  left: 14px !important;
  min-width: $dropdown-width;
}

/deep/ .dropdown-item {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/deep/ .dropdown-header {
  color: $brand;
  font-weight: 600;
}
</style>
